import { useEffect, useState } from "react";
import { ArrowDown } from "lucide-react";
import { useFormInView } from "@/hooks/useFormInView";

export const StickyCta = () => {
  const [scrolled, setScrolled] = useState(false);
  const formInView = useFormInView();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const visible = scrolled && !formInView;

  return (
    <div
      className={`lg:hidden fixed bottom-0 inset-x-0 z-40 p-3 transition-transform duration-300 ${visible ? "translate-y-0" : "translate-y-full pointer-events-none"}`}
      data-testid="sticky-cta-bar"
      data-visible={visible}
    >
      <a
        href="#formulario"
        className="btn-cta flex items-center justify-center gap-2 rounded-2xl py-4 font-extrabold text-base shadow-2xl"
        data-testid="sticky-cta-button"
      >
        <ArrowDown className="h-5 w-5" /> Ir al formulario · Bono $50
      </a>
    </div>
  );
};
